import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { Subscriber, Subscription } from 'rxjs';
import * as moment from 'moment';

import { PurchaseRequestService, PurchaseRequestId } from '../../services/purchase-request.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { UserService } from '../../services/user.service';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { ProductionOrderService, ProductionOrderId } from '../../services/production-order.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-read-purchase-request',
  templateUrl: './read-purchase-request.component.html',
  styleUrls: ['./read-purchase-request.component.css']
})
export class ReadPurchaseRequestComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};

  /* supplierForm: FormGroup;
  supplierError: boolean = false;
  
  suppliers = {};
  suppliersInit: any; */

  purchaseRequests: any[] = [];
  filteredRequests: any[] = [];

  /* modalActionsReqOrder = new EventEmitter<string|MaterializeAction>();
  modalParamsReqOrder = [{dismissible: true}]; */
  modalActionsEraseRequest = new EventEmitter<string|MaterializeAction>();
  modalParamsEraseRequest = [{dismissible: true}];

  idToDelete: string;
  folioToDelete: number;
  ReqOrderId: string;
  
  purchaseRequestSub: Subscription;
  userSub: Subscription[] = [];

  odps: {[odpId: string]: ProductionOrderId} = {};

  // -------- Code for filter, search and pagination --------
  data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Folio', name: "name", sort: 'desc'},
    {title: 'Fecha', name: 'date'},
    {title: 'Fecha req.', name: 'deliveryRequiredDate'},
    {title: 'Proveedor sugerido', name: 'supplierName'},
    {title: 'Emp. Solicitante', name: 'requester'},
    {title: 'OdP', name: 'odpFolio'},
    {title: 'Notas', name: 'notes'},
    {title: 'Ap 1', name: 'approvedIcon1'},
    {title: 'Ap 2', name: 'approvedIcon2'},
    {title: 'OdC', name: 'ordered'},
    {title: 'Cancelado', className: 'center', name: 'canceled_icon'},
    {title: 'Acciones',  name: 'actionGroup', sort: false, actions: {type: 'group', buttons: [
      { name: 'clear', title: '', styleIcon: 'clear', action: 'onCancel', styleClass: 'btn-floating btn waves-effect red lighten-1' },
      {name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit', styleClass: 'btn-floating btn waves-effect light-green darken-1' },
      {name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete', styleClass: 'btn-floating btn waves-effect red darken-2'}
  ]}}
  ];
  page: number = 1;
  itemsPerPage: number = 5;
  maxSize: number = 5;
  numPages: number = 1;
  length: number = 0;

  config: any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
    api: {
      onCancel: this.openModalCancel.bind(this),
      onEdit: this.onEdit.bind(this),
      onDelete: this.onDelete.bind(this)
    }
  };

  constructor(
    private service: PurchaseRequestService,
    private supplierService: CustomerSupplierService,
    private fiscalDataService: FiscalDataService,
    private userService: UserService,
    private settings: CatalogsSettingsService,
    private odpService: ProductionOrderService,
    private fb: FormBuilder,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
      permissionsSubs.unsubscribe();
      this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
      if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
      else this.allowed = true;
    });

    let settingsSub = this.settings.getPayrollSettings('1').subscribe(setting => {
      settingsSub.unsubscribe();
      this.itemsPerPage = setting.tableQuantity;
    });

    this.getRdcs();
  }

  ngOnInit() {
  }
  ngOnDestroy(){
    this.purchaseRequestSub.unsubscribe();
  }
  /* requestToOrder(data: any): any {
    if (data.row.ordered){
      this.router.navigate([`/vw_purchase_order/${data.row.ordered}/fromReq`]);
    } else {
      if(!data.row.approved1 || !data.row.approved2) {
        toast('¡Faltan aprobaciones!', 4000);
      } else {
        this.requestId = data.row.id;
        this.continueReadTo(0);
      }
    }
  } */
  requestId: string = '';
  
  onCellClick(data: any): any {
		this.router.navigate(['/vw_purchase_request/' + data.row.id]);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.router.navigate([`/add_purchase_request`]);
  }

  onEdit({row}){
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
    if(row.approved1 || row.approved2) return toast('Una requisisión aprobada no puede ser modificada.', 2000);
    this.router.navigate([`/edit_purchase_request/${row.id}`]);
  }

  onDelete({row}: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
    if(row.approved1 || row.approved2){
      toast('Una requisisión aprobada no puede ser eliminada.', 2000);
    } else{
      this.openEraseModal(row.id, row.name);
    }
  }

  reasonMsg: string = '';
  cancelingRdc: PurchaseRequestId = null;
  async continueCancel(){
    if(!this.reasonMsg) return toast('Ingrese una justificación.', 2000);
    try{
      let data: Partial<PurchaseRequestId> = {
        canceled: true,
        cancelReasons: [
          ...(this.cancelingRdc.cancelReasons || []),
          {datetime: `${Utils.today}, ${Utils.time}`, msg: this.reasonMsg},
        ],
      };
      await this.service.updatePurchaseRequest(this.cancelingRdc.id, data);
      this.reasonMsg = '';
      this.closeModalCancel();
      toast('Éxito', 2000);
    }catch(error){
      toast('Error inesperado.', 2000);
    }
  }

  deletePurchaseRequest() {
    this.service.deletePurchaseRequest(this.idToDelete);
    this.modalActionsEraseRequest.emit({ action: 'modal', params: ['close'] });
  }

  openEraseModal(id: string, folio: number) {
    this.idToDelete = id;
    this.folioToDelete = folio;
    this.modalActionsEraseRequest.emit({ action: 'modal', params: ['open'] });
  }
  closeEraseModal() {
    this.modalActionsEraseRequest.emit({ action: 'modal', params: ['close'] });
    this.idToDelete = '';
  }
  modalActionsCancel = new EventEmitter<string|MaterializeAction>();
  modalParamsCancel = [{dismissible: true}];
  openModalCancel({row: bill}: {row: PurchaseRequestId}) {
    this.cancelingRdc = bill;
    this.modalActionsCancel.emit({ action: 'modal', params: ['open'] });
  }
  closeModalCancel() {
    this.modalActionsCancel.emit({ action: 'modal', params: ['close'] });
  }

  excludeOrdered: boolean = true;
  retrievedStatus: 'none' | 'ordered' | 'all' = 'none';
  readonly checkIcon = `<i class="small material-icons light-green-text text-darken-1">check_circle</i>`;
  readonly cancelIcon = `<i class="small material-icons red-text text-darken-2">cancel</i>`;
  readonly orderIcon = `<i class="small material-icons blue-text text-darken-1">check_circle</i>`;
  getRdcs(){
    console.log(`Called getRdcs, excludeOrdered: ${this.excludeOrdered}, retrievedStatus: ${this.retrievedStatus}.`);
    let subFunction = tempPurchaseReqs => {
      this.purchaseRequests = tempPurchaseReqs;
      
      this.purchaseRequests.map((request, index) =>  {
        //request.date = moment(request.date).format('YYYY-MM-DD HH:ss');
        this.userSub[index] = this.userService.getUser(request.requester).subscribe(res => {
          this.userSub[index].unsubscribe();
          request.requester = `${res.name} ${res.lastName}`;
        });
        request.approvedIcon1 = (request.approved1) ? this.checkIcon : this.cancelIcon;
        request.approvedIcon2 = (request.approved2) ? this.checkIcon : this.cancelIcon;
        request.ordered = (request.ordered) ? this.orderIcon : this.cancelIcon;

        request.cancelable = true;
        for(let pr of request.productsInRequest) if(pr.ordered) request.cancelable = false;
        request.canceled_icon = request.canceled ? `<i class="small material-icons">done</i>` : `<i class="small material-icons">clear</i>`;

        if(request.supplierRef){
          let sub = this.supplierService.getCustomerSupplier(request.supplierRef.id).subscribe(supplier => {
            sub.unsubscribe();
            request.supplierName = supplier.name;
          });
        }else{
          request.supplierName = '';
        }

        if(request.productionOrderRef){
          let {id: odpId} = request.productionOrderRef;
          if(!this.odps[odpId]){
            let odpSub = this.odpService.getProductionOrder(odpId).subscribe(([odp]) => {
              odpSub.unsubscribe();
              this.odps[odp.id] = odp;
              request.odpFolio = odp.name;
            });
          }else{
            request.odpFolio = this.odps[odpId].name;
          }
        }else{
          request.odpFolio = '';
        }
      });
      this.applyFilter();
    };

    switch(this.retrievedStatus){
      case 'none':
        this.retrievedStatus = 'ordered';
        this.purchaseRequestSub = this.service.getPurchaseRequests({excludeOrdered: true}).subscribe(subFunction);
        break;
      case 'ordered':
        if(this.excludeOrdered) break;
        this.retrievedStatus = 'all';
        if(this.purchaseRequestSub) this.purchaseRequestSub.unsubscribe();
        this.purchaseRequestSub = this.service.getPurchaseRequests({excludeOrdered: false}).subscribe(subFunction);
        break;
      case 'all':
        break;
    }
  }
  applyFilter(){
    console.log(`Called applyFilter, excludeOrdered: ${this.excludeOrdered}, retrievedStatus: ${this.retrievedStatus}.`);
    if(!this.excludeOrdered && this.retrievedStatus != 'all') return this.getRdcs();
    this.data = this.purchaseRequests.filter(rdc => !this.excludeOrdered || rdc.ordered == this.cancelIcon);
    this.length = this.data.length;
    this.onChangeTable(this.config);
  }

  /*********** Filter, sort, and pagination */

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }
    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }
  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }
  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }
  changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

}